import React, { useState, useEffect } from 'react';
import axios from '../Axiosinstance'; // Make sure to import axios properly
import { Table, TableHead, TableBody, TableRow, TableCell, TableContainer, Box, Button, TextField, Dialog, DialogTitle, DialogContent, DialogActions, Grid, Typography, Paper, TablePagination } from '@mui/material';
import { toast } from 'react-toastify'; // Assuming you are using react-toastify for notifications
import CircularProgress from '@mui/material/CircularProgress';

import ARIALItalicLight from '../fonts/ARIALI1.TTF'
import calibriFontItalic from '../fonts/calibri-italic.ttf';
import ArialitalicBold2 from '../fonts/ArialMdmItl.ttf'
import ArialItalicBold from '../fonts/ArialCEBoldItalic.ttf'

import { removeBracketedText } from '../Axiosinstance';
import * as XLSX from "xlsx";
import pdfTemplate from '../All/registration-receipt.pdf';
import Instalment from '../pdf/instalment-receipt.pdf'
import calibriFontBold from '../fonts/CalibriBold.ttf'
import calibriFont from '../fonts/calibri.ttf'
import fontkit from '@pdf-lib/fontkit';
import DownloadIcon from '@mui/icons-material/Download';
import { PDFDocument, rgb, StandardFonts } from 'pdf-lib';
import Modal from 'react-bootstrap/Modal';
import html2canvas from 'html2canvas';
import { format } from 'date-fns';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMapMarkerAlt, faPhone } from '@fortawesome/free-solid-svg-icons';
import jsPDF from 'jspdf';
import { saveAs } from 'file-saver';
import { useNavigate } from "react-router-dom";
import { buttonBackgroundColor } from '../common';
import EditPayment from "./EditPayment"; 

const CustomPop = ({
  showPop,
  handleClosePop,
  handleSubmit,
  selectedStudent,
  remarks,
  handleRemarksChange,
  amount,
  handleAmountChange,
  modelOpen,
  registrationId
}) => {
  const [loading, setLoading] = useState(false);
  const [amountError, setAmountError] = useState('');
  const [discountAmount, setDiscountAmount] = useState('');
  const [discountLoading, setDiscountLoading] = useState(false);
  const [showDiscount, setShowDiscount] = useState(false);
  const [totalWantToPaid, setTotalWantToPaid] = useState(null);
  const [remark, setRemark] = useState('');
  const [showRemark, setShowRemark] = useState(false);
  const [paymentData, setPaymentData] = useState();
  const [totalPaid, setTotalPaid] = useState(null);



  useEffect(() => {
    const fetchPaymentInfo = async () => {
      if (!selectedStudent?.id || !showPop) return;

      try {
        const response = await axios.get(
          `registrationadvances/paymentDetails-info/${selectedStudent.registrationAdvanceId || registrationId}`
        );
        // console.log('registrationId',registrationId)
        // console.log('selectedStudent',selectedStudent.registrationAdvanceId)
        setTotalWantToPaid(response.data.totalWanttoPaid || 0);
        setTotalPaid(response.data.totalPaid || 0);
        console.log(response.data, "response.data");
        setPaymentData(response.data);

      } catch (error) {
        console.error('Error fetching payment info:', error);
        alert('Failed to fetch payment info. Please try again.');
      }
    };

    fetchPaymentInfo();
  }, [selectedStudent, showPop]);

  const validateAmount = (value) => {
    if (value <= 0) {
      setAmountError('Amount must be greater than 0');
      return false;
    }
    if (value > totalWantToPaid) {
      setAmountError(`Amount cannot exceed the total of $${totalWantToPaid}`);
      return false;
    }
    setAmountError('');
    return true;
  };

  const localHandleAmountChange = (e) => {
    const value = parseFloat(e.target.value) || 0;
    handleAmountChange(e);
    validateAmount(value);
  };

  const handleSubmitalert = async () => {
    const isConfirmed = window.confirm('Are you sure you want to approve?');
    if (isConfirmed) {
      if (validateAmount(amount)) {
        setLoading(true);
        await handleSubmit(registrationId || selectedStudent );
        setLoading(false);
      }
    }
  };

  const handleAddDiscount = async () => {
    if (!discountAmount || discountAmount <= 0) {
      alert('Please enter a valid discount amount.');
      return;
    }
    if (!remark) {
      alert('Please enter a remark.');
      return;
    }

    // if (paymentData.lastRegistrationfeedetail.type === "RegistrationFee") {
    //   if (paymentData.lastRegistrationfeedetail.registrationFeeRemaining) {
    //     // alert(`discount should be less than or equal to ${(paymentData.lastRegistrationfeedetail.registrationFeeRemaining)-50}`);
    //     alert(`discount should be less than or equal to ${(paymentData.lastRegistrationfeedetail.registrationFeeRemaining) - 50}`);
    //     return;
    //   }

    // }
    if (
      paymentData?.lastRegistrationfeedetail &&
      paymentData.lastRegistrationfeedetail.type === "RegistrationFee" &&
      paymentData.lastRegistrationfeedetail.registrationFeeRemaining !== 0
    ) {
      if (discountAmount > (paymentData.lastRegistrationfeedetail.registrationFeeRemaining - 50)) {

        alert(`discount should be less than or equal to ${(paymentData.lastRegistrationfeedetail.registrationFeeRemaining) - 50}`);
        return;
      }

    }

    setDiscountLoading(true);
    try {
      // Include both discountAmount and remark in the payload
      await axios.post(`/registrationadvances/${selectedStudent.registrationAdvanceId || registrationId}/discount`, {
        discountAmount,
        remark, // Add remark here
      });
      alert(`Discount of ${discountAmount} added successfully!`);
      setDiscountAmount('');
      setRemark(''); // Reset the remark field after successful submission
      setShowDiscount(false);
    } catch (error) {
      console.error('Error adding discount:', error);
      alert('Failed to add discount. Please try again.');
    } finally {
      setDiscountLoading(false);
    }
  };


  const handleRemarkChange = (event) => {
    setRemark(event.target.value);
  };

  const popupStyle = {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 1000,
    opacity: showPop ? 1 : 0,
    transition: 'opacity 0.3s',
    pointerEvents: showPop ? 'auto' : 'none',
  };

  const popupContentStyle = {
    background: '#fff',
    padding: '20px',
    borderRadius: '10px',
    width: '500px',
    maxWidth: '90%',
    boxShadow: '0 0 10px rgba(0, 0, 0, 0.1)',
    position: 'relative',
  };

  const closeButtonStyle = {
    position: 'absolute',
    top: '10px',
    right: '10px',
    fontSize: '24px',
    cursor: 'pointer',
  };

  return (
    <div style={popupStyle}>
      <div style={popupContentStyle}>
        <span style={closeButtonStyle} onClick={handleClosePop}>
          &times;
        </span>
        <h2>Payment Details</h2>
        <div>
          <TextField
            margin="dense"
            label="Name"
            type="text"
            fullWidth
            value={selectedStudent?.name || ''}
            disabled
          />
          {/* Conditionally render totalWantToPaid only when showDiscount is false */}
          {!showDiscount && (
            <TextField
              margin="dense"
              label="Total Want to Paid"
              type="text"
              fullWidth
              value={totalWantToPaid !== null ? `$${totalWantToPaid}` : 'Loading...'}
              disabled
            />
          )}

          {/* Render Add Discount only when there is an outstanding amount */}
          {totalWantToPaid > 0 && (
            <div>
              <label>
                <input
                  type="checkbox"
                  checked={showDiscount}
                  onChange={(e) => setShowDiscount(e.target.checked)}
                  style={{ marginRight: '5px' }}
                />
                Add Discount
              </label>
            </div>
          )}

          {showDiscount ? (
            <div style={{ marginBottom: '20px' }}>
              <TextField
                margin="dense"
                label="Discount Amount"
                type="number"
                fullWidth
                value={discountAmount}
                onChange={(e) => setDiscountAmount(e.target.value)}
              />

              <TextField
                margin="dense"
                label="Remark"
                type="text"
                fullWidth
                value={remark}
                onChange={handleRemarkChange}
              />
              <Button
                variant="contained"
                color="secondary"
                onClick={handleAddDiscount}
                disabled={discountLoading}
                style={{
                  marginTop: '10px',
                  backgroundColor: buttonBackgroundColor,
                  color: 'white',
                }}
              >
                {discountLoading ? <CircularProgress size={24} /> : 'Add Discount'}
              </Button>
            </div>
          ) : totalWantToPaid > 0 ? (
            <>
              {/* Outstanding Amount Fields */}
              <TextField
                margin="dense"
                label="Amount"
                type="number"
                fullWidth
                value={amount}
                onChange={localHandleAmountChange}
                helperText={amountError}
                error={!!amountError}
                disabled={totalWantToPaid === 0} // Disable if totalWantToPaid is 0
              />
              <TextField
                margin="dense"
                label="Remarks"
                type="text"
                fullWidth
                value={remarks}
                onChange={handleRemarksChange}
              />
              <Box display="flex" mt={2} gap={2}>
                <Button
                  variant="contained"
                  // color="primary"
                  onClick={handleSubmitalert}
                  disabled={loading}
                  style={{
                    backgroundColor: buttonBackgroundColor,
                    borderRadius: '5px',
                    textTransform: 'none',
                    padding: '8px 16px',
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  {loading ? <CircularProgress size={24} /> : 'Submit'}
                </Button>
                <Button
                  variant="contained"
                   color="error"
                  onClick={handleClosePop}
                  style={{
                    borderRadius: '5px',
                    textTransform: 'none',
                    padding: '8px 16px',
                    // backgroundColor: '#1976d2',
                    // color: 'white',
                  }}
                >
                  Close
                </Button>
                
              </Box>
            </>
          ) : (
            <div style={{ marginTop: '20px', textAlign: 'center' }}>
              <p style={{ color: 'green', fontWeight: 'bold' }}>
                There is no outstanding amount.
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};



const StudentList = () => {
  const [students, setStudents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showPop, setShowPop] = useState(false);
  const [selectedStudent, setSelectedStudent] = useState(null);
  const [amount, setAmount] = useState('');
  const [remarks, setRemarks] = useState('');
  const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
  const [studentInfo, setStudentInfo] = useState(null);
  const [studentDetails, setStudentDetails] = useState(null);
  const [data, setData] = useState(null);
  const [scheduleData, setScheduleData] = useState([]);
  const [dataForprop, setDataForprop] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [modelOpen, setModelOpen] = useState('')
  // const [currentPage, setCurrentPage] = useState(1);
  const [searchText, setSearchText] = useState('');
  const [registrationId, setRegistrationId] = useState();
  const [showEditModal, setShowEditModal] = useState(false);
  const [editData, setEditData] = useState(null);
  const [editIndex, setEditIndex] = useState(null);
  const [editStudentId, setEditStudentId] = useState(null);


  const [pdfUrl, setPdfUrl] = useState(null);
  const [open, setOpen] = useState(false);
  const [pdfFileName, setPdfFileName] = useState('');

  const handleDownload = () => {
    if (!pdfUrl || !pdfFileName) return;

    const a = document.createElement('a');
    a.href = pdfUrl;
    a.download = pdfFileName;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  };

  const handleClose = () => {
    setOpen(false);
    setPdfUrl(null);
  };
  // const displayedStudents = students.slice(
  //   (currentPage - 1) * studentsPerPage,
  //   currentPage * studentsPerPage
  // );
  // const handleChangePage = (event, newPage) => {
  //   setCurrentPage(newPage + 1);
  // };

  // const handleChangeRowsPerPage = (event) => {
  //   setStudentsPerPage(parseInt(event.target.value, 10));
  //   setCurrentPage(1); // Reset to first page
  // };


  const navigate = useNavigate();
  // const handleEdit = (installment, index, id, allinstallments) => {
  //   navigate("/edit-payment", { state: { installment, index, id, allinstallments } });
  // };

  const UserType = localStorage.getItem('usertype');
  const loggedInUserId = localStorage.getItem('loggedInUserId');

  // useEffect(() => {
  //   const fetchStudents = async () => {
  //     let response;
  //     try {
  //       setLoading(true); // Set loading to true when starting to fetch data
  //       if (UserType == 4) {
  //         response = await axios.get('registrationadvances/activeStudentDetailss'); // Replace with your API endpoint
  //         console.log("4 id called")
  //       }
  //       else {
  //         response = await axios.get('registrationadvances/unapprovedPaymentTypes/active', {
  //           params: {
  //             approveReference: loggedInUserId
  //           }
  //         });
  //         console.log("3 id called")
  //       }
  //       // setStudents(response.data.reverse()); // Assuming response.data is an array of student objects
  //       setStudents(response.data);
  //       setLoading(false); // Set loading to false when data is loaded
  //     } catch (error) {
  //       console.error('Error fetching students:', error);
  //       setLoading(false); // Set loading to false in case of an error
  //     }
  //   };

  //   fetchStudents();
  // }, []); // Empty dependency array ensures this effect runs once on component mount
useEffect(() => {
    const fetchStudents = async () => {
      let response;
      try {
        setLoading(true); // Set loading to true when starting to fetch data
       
          response = await axios.get('registrationadvances/activeStudentDetailss'); // Replace with your API endpoint
          console.log("4 id called")
        
       
        // setStudents(response.data.reverse()); // Assuming response.data is an array of student objects
        setStudents(response.data);
        setLoading(false); // Set loading to false when data is loaded
      } catch (error) {
        console.error('Error fetching students:', error);
        setLoading(false); // Set loading to false in case of an error
      }
    };

    fetchStudents();
  }, []); // Empty dependency array ensures this effect runs once on component mount

  const handleViewStudent = (student, model, registrationId) => {
    console.log('Viewing student:', student);
    setSelectedStudent(student);
    setShowPop(true);
    setModelOpen(model)
    setRegistrationId(registrationId)
  };
 

  const handleClosePop = () => {
    console.log('Closing popup');
    setShowPop(false);
    setSelectedStudent(null);
    setAmount('');
    setRemarks('');
  
  if (modelOpen === 'in') {
    setShowModal(true);
    }

  };
  const handleEdit = (installment, index,  id, allInstallments) => {
    setEditData({
      installment,
      index,
      id,
      allinstallments: allInstallments,
    });
    setShowEditModal(true);
  };

  // const [discounts, setDiscounts] = useState({}); // To store the discounts for each student

  // const fetchDiscount = async (studentId) => {
  //   try {
  //     const response = await axios.get(`/registrationadvances/${studentId}/total-discount`);
  //     setDiscounts((prevDiscounts) => ({
  //       ...prevDiscounts,
  //       [studentId]: response.data.discount, // Assuming the response contains a 'discount' field
  //     }));
  //   } catch (error) {
  //     console.error("Error fetching discount:", error);
  //   }
  // };


  const handleSubmit = async (studentId) => {
    console.log('studentId.registrationAdvanceId',studentId)
    try {
      // Step 1: Update payment amount
      await axios.post(
        `registrationadvances/${studentId.registrationAdvanceId || studentId}/PaymentAmount`,
        { paymentAmount: amount }
      );

      // Step 2: Update course fee details
      await axios.post(
        `/registrationadvances/${studentId.registrationAdvanceId || studentId}/course-fee-details`,
        {
          sessionId: studentId.registrationAdvanceId, // Use student's ID as sessionId
          sessionDate: new Date(),
          amount,
          paymentMode: 'offline',
          remarks,
        }
      );

      console.log('Registration details updated successfully');
      setShowPop(false); // Close the modal

      // Open confirmation dialog
      setConfirmDialogOpen(true);

      // Call the confirm approval process
      handleConfirmApproval(studentId.registrationAdvanceId|| studentId);
   console.log('studentId.registrationAdvanceId',studentId.registrationAdvanceId)
  console.log('studentId.id',studentId) 
  console.log('studentId',studentId)

  } catch (error) {
      console.error('Error updating registration details:', error);
      toast.error('Error updating registration details. Please try again.');
    }
  };

  const handleConfirmApproval = async (sessionId) => {
    console.log('sessionId',sessionId)
    try {
      // Step 3: Approve payment
      // await axios.post(`/registrationadvances/${sessionId}/course-fee-details/set-status`, { status: 'Paid' });
      // toast.success('Payment approved successfully.');

      // Fetch additional student information (optional)
      const infoResponse = await axios.get(`/registrationadvances/info/${sessionId}`);
      console.log('Fetched student information:', infoResponse.data);

      // Step 4: Initiate background API calls for receipts
      // setTimeout(() => {
      //   Promise.all([
      //     axios.post(`/registrationadvances/send-receipt/${sessionId}`),
      //     axios.post(`/registrationadvances/send-receipts/${sessionId}`)
      //   ])
      //     .then(() => {
      //       console.log('Receipts sent successfully in the background.');
      //     })
      //     .catch((error) => {
      //       console.error('Error sending receipts:', error);
      //     });
      // }, 0); // Execute in the background
    } catch (error) {
      console.error('Error approving payment:', error);
      toast.error('Error approving payment. Please try again.');
    } finally {
      setConfirmDialogOpen(false);
      setAmount(''); // Reset amount input
    }
  };


  const handleCloseModal = () => {
    setShowModal(false);
    setShowModal(false);
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  };


  function formatDateEnd(dateString) {
    const options = { day: '2-digit', month: '2-digit', year: 'numeric' };
    const date = new Date(dateString);
    return new Intl.DateTimeFormat('en-GB', options).format(date);
  }

  const handleAmountChange = (e) => {
    setAmount(e.target.value);

  };

  const handleRemarksChange = (e) => {
    setRemarks(e.target.value);
  };

  const handleshowStudent = async (student) => {
    try {
      // First API call
      const response1 = await axios.get(`/registrationadvances/${student.registrationAdvanceId}`);
      const { scheduleDate, batch, ...studentData1 } = response1.data;


      // Copy batch details to studentData
      const updatedStudentData1 = { ...studentData1, batch };

      // Create a map for moduleDetails based on id
      const moduleDetailsMap = {};
      batch?.moduleDetails.forEach(module => {
        moduleDetailsMap[module.id] = module.moduleName;
      });

      // Map the module details to the schedule data based on startModulus
      const updatedScheduleData = scheduleDate.map(schedule => {
        // Log the current schedule's startModulus
        console.log('schedule.startModulus:', schedule.startModulus);

        // Get the module based on the startModulus index
        const moduleDetail = batch?.moduleDetails[schedule.startModulus - 1];

        // Log the found moduleDetail
        console.log('Found moduleDetail:', moduleDetail);

        return {
          ...schedule,
          moduleDetail: moduleDetail ? moduleDetail.moduleName : 'N/A'  // Assign moduleName or 'N/A' if no module is found
        };
      });


      // Second API call
      const response2 = await axios.get(`/registrationadvances/info/${student.registrationAdvanceId}`);
      const { courseFeeDetails, installmentsPaid, amount1, type, id } = response2.data;

      setStudentInfo(response2.data);
      // Set state with data from both API calls
      setStudentDetails(updatedStudentData1);
      setScheduleData(updatedScheduleData);
      // console.log(response1.data)
      // console.log("sty",updatedStudentData1)
      // console.log("dta",updatedScheduleData)
      setData({ courseFeeDetails, installmentsPaid, amount1, type, id });

      //for props 
      setDataForprop(response1.data);
      console.log("cxcxcxczc:",dataForprop)
      // Show modal
      setShowModal(true);

    } catch (error) {
      console.error('Error fetching student details:', error);
    }
  };
  // const numberToWords = (number) => {
  //   const ones = ['', 'one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine'];
  //   const teens = ['', 'eleven', 'twelve', 'thirteen', 'fourteen', 'fifteen', 'sixteen', 'seventeen', 'eighteen', 'nineteen'];
  //   const tens = ['', 'ten', 'twenty', 'thirty', 'forty', 'fifty', 'sixty', 'seventy', 'eighty', 'ninety'];
  //   const suffixes = ['', 'thousand'];


  //   const numToWords = (num) => {
  //     let words = '';
  //     if (num >= 1000) {
  //       words += numToWords(Math.floor(num / 1000)) + ' thousand ';
  //       num %= 1000;
  //     }
  //     if (num >= 100) {
  //       words += ones[Math.floor(num / 100)] + ' hundred ';
  //       num %= 100;
  //     }
  //     if (num >= 20) {
  //       words += tens[Math.floor(num / 10)] + ' ';
  //       num %= 10;
  //     }
  //     if (num > 0) {
  //       if (num >= 11 && num <= 19) {
  //         words += teens[num - 10] + ' ';
  //       } else {
  //         words += ones[num] + ' ';
  //       }
  //     }
  //     return words.trim();
  //   };



  //   if (number === 0) return 'zero';
  //   return numToWords(number);
  // };

  const numberToWords = (number) => {
    const ones = ['', 'one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine'];
    const teens = ['ten', 'eleven', 'twelve', 'thirteen', 'fourteen', 'fifteen', 'sixteen', 'seventeen', 'eighteen', 'nineteen'];
    const tens = ['', '', 'twenty', 'thirty', 'forty', 'fifty', 'sixty', 'seventy', 'eighty', 'ninety'];

    const numToWords = (num) => {
      let words = [];

      if (num >= 1000) {
        words.push(ones[Math.floor(num / 1000)] + ' thousand');
        num %= 1000;
      }
      if (num >= 100) {
        words.push(ones[Math.floor(num / 100)] + ' hundred');
        num %= 100;
      }
      if (num >= 10 && num <= 19) {
        words.push(teens[num - 10]);
        return words.join(' '); // Directly return since teens (11-19) are standalone
      }
      if (num >= 20) {
        words.push(tens[Math.floor(num / 10)]);
        num %= 10;
      }
      if (num > 0) {
        words.push(ones[num]);
      }

      return words.join(' ').trim();
    };

    return number === 0 ? 'zero' : numToWords(number);
  };

  // for (let i = 1; i <= 200; i++) {
  //   console.log(`${i}: ${numberToWords(i)}`);
  // }


  const toUpperCaseString = (str) => {
    return str?.toUpperCase();
  };
  const toUpperCaseString1 = (str) => {
    // Remove trailing numbers within parentheses
    return str.replace(/\(\d+\)$/, '').toUpperCase();
  };


  const getYear = (dateString) => {
    const date = new Date(dateString);
    return date.getFullYear().toString().slice(-2); // Get last two digits of the year
  };

  const toUpperCaseString11 = (dateString) => {
    const date = new Date(dateString);
    const month = getMonthName(date.getMonth());
    const year = date.getFullYear();
    return `${month} ${year}`;
  };

  const getMonthName = (monthNumber) => {
    const monthNames = [
      "JANUARY", "FEBRUARY", "MARCH", "APRIL", "MAY", "JUNE",
      "JULY", "AUGUST", "SEPTEMBER", "OCTOBER", "NOVEMBER", "DECEMBER"
    ];
    return monthNames[monthNumber];
  };

  const getOrdinalSuffix = (num) => {
    console.log(num);
    console.log('Input number:', num); // Debugging: print the number being passed
    const j = num % 10;
    const k = num % 100;

    console.log('Last digit (j):', j, 'Last two digits (k):', k); // Debugging: print the results of modulus operations

    if (k >= 11 && k <= 13) {
      return "th"; // Handle 11th, 12th, 13th
    }
    switch (j) {
      case 1:
        return "st";
      case 2:
        return "nd";
      case 3:
        return "rd";
      default:
        return "th";
    }
  };

  const registrationFee = studentInfo?.installmentsPaid?.length > 0 ? studentInfo.installmentsPaid[studentInfo.installmentsPaid.length - 1].amount : 0;
  const gst = registrationFee - (registrationFee / 1.09);
  const sumOfDollars = numberToWords(registrationFee);


  const handlePdfEdit = async (installment, index) => {
    try {
      const pdfBytes = await fetch(pdfTemplate).then((res) => res.arrayBuffer());
      const pdfDoc = await PDFDocument.load(pdfBytes);
      const pages = pdfDoc.getPages();
      const firstPage = pages[0];
      pdfDoc.registerFontkit(fontkit);


      // Example: Assuming formValues contains user input
      // const { invoiceNo, totalFee, installmentCount, feeType } = formValues;

      // Load the font
      const calibriFontBytes = await fetch(calibriFont).then((res) => res.arrayBuffer());
      const calibriFontEmbed = await pdfDoc.embedFont(calibriFontBytes);

      const calibriFontBoldBytes = await fetch(calibriFontBold).then((res) => res.arrayBuffer());
      const calibriFontBoldEmbed = await pdfDoc.embedFont(calibriFontBoldBytes);

      const calibriFontItalicBytes = await fetch(calibriFontItalic).then((res) => res.arrayBuffer());
      const calibriFontItalicEmbed = await pdfDoc.embedFont(calibriFontItalicBytes);

      const ArialItalicLight = await fetch(ARIALItalicLight).then((res) => res.arrayBuffer());
      const ArialItalicLightEmbed = await pdfDoc.embedFont(ArialItalicLight);
      // Example: Draw text using the embedded font and user input values
      // firstPage.drawText(`Installment Count: ${installment.installmentCount}`, { x: 50, y: 600, size: 12, font: calibriFontEmbed, color: rgb(0, 0, 0) });

      firstPage.drawText(`TAX INVOICE`, { x: 420, y: 775, size: 19, font: calibriFontBoldEmbed, color: rgb(0, 0, 0) });
      firstPage.drawText(`GST No. 201322342Z`, { x: 420, y: 760, size: 12, font: calibriFontEmbed, color: rgb(0, 0, 0) });

      firstPage.drawText(
        `  ${studentInfo.late
          ? (index === 0
            ? formatDate(studentInfo.scheduleDate)
            : formatDate(installment.sessionDate)
          )
          : formatDate(installment.sessionDate)
        }`, { x: 380.8, y: 666, size: 9, font: calibriFontBoldEmbed, color: rgb(0, 0, 0) });
      firstPage.drawText(` $${installment.amount}`, { x: 478, y: 565, size: 9, font: calibriFontEmbed, color: rgb(0, 0, 0) });
      firstPage.drawText(` $${installment.amount}`, { x: 478, y: 493, size: 9, font: calibriFontBoldEmbed, color: rgb(0, 0, 0) });

      firstPage.drawText(` $${((installment.amount) - (installment.amount / 1.09)).toFixed(2)})`, { x: 152, y: 545, size: 9, font: calibriFontItalicEmbed, color: rgb(0, 0, 0) });
      // firstPage.drawText(` ${installment.amount} (OMT)`, { x: 142, y: 555, size: 9, font: calibriFontEmbed, color: rgb(0, 0, 0) });
      firstPage.drawText(` ${installment.amount}`, { x: 142, y: 555, size: 9, font: calibriFontEmbed, color: rgb(0, 0, 0) });
      if (installment.paymentMode === 'online') {
        firstPage.drawText(` ${installment.amount} (OMT)`, { x: 142, y: 555, size: 9, font: calibriFontEmbed, color: rgb(0, 0, 0) });
      }
      firstPage.drawText(` ${toUpperCaseString1(numberToWords(installment.amount))} DOLLARS ONLY`, { x: 131.5, y: 495, size: 9, font: calibriFontEmbed, color: rgb(0, 0, 0) });

      firstPage.drawText(`OFFICIAL INVOICE NO:`, { x: 360, y: 677, size: 9, font: calibriFontBoldEmbed, color: rgb(0, 0, 0) });

      if (studentInfo) {
        // const invoiceString = `JA${getYear(studentInfo.date)}-${studentInfo.id}-${studentInfo.nric}-R`;
        const invoiceString = `JA${getYear(installment.sessionDate)}-${String(installment.sequenceNumber).padStart(4, '0')}-${studentInfo.nric}-R`;
        // const x = 410;
        const x = 445;
        const y = 677;
        const size = 9;
        const font = calibriFontBoldEmbed;
        firstPage.drawText(invoiceString, { x, y, size, font, color: rgb(0, 0, 0) });

        // Measure the width of the text
        const textWidth = font.widthOfTextAtSize(invoiceString, size);
        // Draw the underline
        firstPage.drawLine({
          start: { x, y: y - 1 },
          end: { x: x + textWidth, y: y - 1 },
          thickness: 0.5,
          color: rgb(0, 0, 0),
        });
        firstPage.drawText(` ${toUpperCaseString1(studentInfo.name)}`, { x: 184, y: 641.6, size: 9, font: calibriFontBoldEmbed, color: rgb(0, 0, 0) });
        firstPage.drawText(` ${toUpperCaseString1(studentInfo.nric)}`, { x: 184, y: 629.3, size: 9, font: calibriFontBoldEmbed, color: rgb(0, 0, 0) });
        firstPage.drawText(` ${toUpperCaseString1(studentInfo.course)}`, { x: 184, y: 617, size: 9, font: calibriFontBoldEmbed, color: rgb(0, 0, 0) });
        firstPage.drawText(` ${toUpperCaseString11(studentInfo.startModuleDate)}`, { x: 184, y: 605, size: 9, font: calibriFontBoldEmbed, color: rgb(0, 0, 0) });
        firstPage.drawText('This is computer generated document no signature required.', { x: 69, y: 450, size: 9, font: calibriFontBoldEmbed, color: rgb(0, 0, 0) });
        // firstPage.drawText(` ${toUpperCaseString1(studentInfo.approver)}`, { x: 100.5, y: 479, size: 9, font: calibriFontEmbed, color: rgb(0, 0, 0) });
        firstPage.drawText(` ${installment.registrationFeeRemaining}`, { x: 109, y: 522, size: 9, font: calibriFontEmbed, color: rgb(0, 0, 0) });


        // if (installment.discountAmount !== 0 && installment.discountAmount !== null) {
        //   firstPage.drawText(` Discount:$${installment.discountAmount}`, { x: 70, y: 533, size: 9, font: calibriFontEmbed, color: rgb(0, 0, 0) });
        // }

        if (studentInfo.amount1 != 0 && index === 0) {
          // If studentinfo.amount1 is not equal to 0, display the discount
          firstPage.drawText(` Discount:$${studentInfo.amount1}`, {
            x: 70,
            y: 533,
            size: 9,
            font: calibriFontEmbed,
            color: rgb(0, 0, 0)
          });
        } else if (installment.discountAmount !== 0 && installment.discountAmount !== null) {
          // If installment.discountAmount is not 0 and not null, display the discount
          firstPage.drawText(` Discount:$${installment.discountAmount}`, {
            x: 70,
            y: 533,
            size: 9,
            font: calibriFontEmbed,
            color: rgb(0, 0, 0)
          });
        }

        //   firstPage.drawText(` ${installment.registrationFeeRemaining}`, { x: 109, y: 522, size: 9, font: calibriFontEmbed, color: rgb(0, 0, 0) });

        // firstPage.drawText(` ${feeDetail.courseFeeRemaining}`, { x: 156, y: 507.5, size: 9, font: calibriFontItalicBoldEmbed, color: rgb(0, 0, 0) });

        // Add more student details as needed
      }

      // Save the PDF document
      // const pdfBytesEdited = await pdfDoc.save();
      // const blob = new Blob([pdfBytesEdited], { type: 'application/pdf' });
      // saveAs(blob, `${toUpperCaseString(studentInfo.name)}-REGISTRATION-RECEIPT.pdf`);

      const pdfBytesModified = await pdfDoc.save();
      const pdfBlob = new Blob([pdfBytesModified], { type: 'application/pdf' });
      const pdfUrl = URL.createObjectURL(pdfBlob);
      // window.open(pdfUrl, '_blank');
      // saveAs(pdfBlob, `${toUpperCaseString(studentInfo.name)}-REG-${installment.sequenceNumber}.pdf`);
      const studentName = studentInfo.name.replace(/\s+/g, '_');
      const fileName = `${studentName}_REG_${installment.sequenceNumber}.pdf`;

      setPdfUrl(pdfUrl);
      setPdfFileName(fileName);
      setOpen(true); // Open dialog
    } catch (error) {
      console.error('Error editing PDF:', error);
    }
  };


  const handlePdfEdit1 = async (feeDetail, type, sequenceNumber) => {
    console.log("feedetail", feeDetail)
    try {
      const pdfBytes = await fetch(Instalment).then((res) => res.arrayBuffer());
      const pdfDoc = await PDFDocument.load(pdfBytes);
      const pages = pdfDoc.getPages();
      const firstPage = pages[0];
      pdfDoc.registerFontkit(fontkit);


      // Example: Assuming formValues contains user input
      // const { invoiceNo, totalFee, installmentCount, feeType } = formValues;

      // Load the font
      const calibriFontBytes = await fetch(calibriFont).then((res) => res.arrayBuffer());
      const calibriFontEmbed = await pdfDoc.embedFont(calibriFontBytes);


      const calibriFontBoldBytes = await fetch(calibriFontBold).then((res) => res.arrayBuffer());
      const calibriFontBoldEmbed = await pdfDoc.embedFont(calibriFontBoldBytes);

      const calibriFontItalicBytes = await fetch(ArialitalicBold2).then((res) => res.arrayBuffer());
      const calibriFontItalicEmbed = await pdfDoc.embedFont(calibriFontItalicBytes);

      const calibriFontItalicBoldBytes = await fetch(ArialItalicBold).then((res) => res.arrayBuffer());
      const calibriFontItalicBoldEmbed = await pdfDoc.embedFont(calibriFontItalicBoldBytes);

      const ArialItalicLight = await fetch(ARIALItalicLight).then((res) => res.arrayBuffer());
      const ArialItalicLightEmbed = await pdfDoc.embedFont(ArialItalicLight);


      // Example: Draw text using the embedded font and user input values
      firstPage.drawText(`  ${formatDate(feeDetail.sessionDate)}`, { x: 384, y: 629.5, size: 9, font: calibriFontBoldEmbed, color: rgb(0, 0, 0) });
      firstPage.drawText(` $${feeDetail.amount}`, { x: 475.5, y: 555, size: 9, font: calibriFontEmbed, color: rgb(0, 0, 0) });
      firstPage.drawText(` ${feeDetail.amount}`, { x: 483.5, y: 474, size: 9, font: calibriFontBoldEmbed, color: rgb(0, 0, 0) });

      firstPage.drawText(` $${((feeDetail.amount) - (feeDetail.amount / 1.09)).toFixed(2)})`, { x: 184, y: 530, size: 9, font: calibriFontItalicBoldEmbed, color: rgb(0, 0, 0) });
      // firstPage.drawText(` ${feeDetail.installmentCount} ${' '} Instalment $${feeDetail.amount} (OMT)`, { x: 75, y: 540.8, size: 9, font: ArialItalicLightEmbed, color: rgb(0, 0, 0) });
      const installmentText = feeDetail.installmentCounts
        .map((count) => `${count}${getOrdinalSuffix(count)}`)
        .join(","); // Join them with a space

      // Now, use this in your drawText
      firstPage.drawText(`${installmentText} Instalment $${feeDetail.amount}`, { x: 77, y: 540.8, size: 9, font: calibriFontItalicBoldEmbed, color: rgb(0, 0, 0) });
      // firstPage.drawText(` ${feeDetail.installmentCounts} ${' '} Instalment $${feeDetail.amount} `, { x: 75, y: 540.8, size: 9, font: calibriFontItalicBoldEmbed, color: rgb(0, 0, 0) });
      if (feeDetail.paymentMode === 'online') {
        firstPage.drawText(` (OMT)`, { x: 175, y: 541, size: 9, font: calibriFontItalicBoldEmbed, color: rgb(0, 0, 0) });
      }

      // firstPage.drawText(` ${getOrdinalSuffix(feeDetail.installmentCounts)}`, { x: 81, y: 545, size: 6, font: calibriFontItalicBoldEmbed, color: rgb(0, 0, 0) });
      firstPage.drawText(` ${toUpperCaseString1(numberToWords(feeDetail.amount))} DOLLARS ONLY`, { x: 141.5, y: 475.3, size: 9, font: calibriFontBoldEmbed, color: rgb(0, 0, 0) });

      const currentInstallments = feeDetail.installmentCounts || [];
      let installmentDisplayText = "";

      // if (feeDetail.remainingBalance === 0) {
      //   // If there is no remaining balance, show the next installment count only
      //   const lastInstallment = currentInstallments[currentInstallments.length - 1] || 0;
      //   installmentDisplayText = `${lastInstallment + 1}${getOrdinalSuffix(lastInstallment + 1)} Installment`;
      // } else {
      //   // If there is a remaining balance, include both current balance and next installment
      //   const lastInstallment = currentInstallments[currentInstallments.length - 1] || 0;
      //   installmentDisplayText = `${lastInstallment}${getOrdinalSuffix(lastInstallment)} Balance, ${lastInstallment + 1}${getOrdinalSuffix(lastInstallment + 1)} Installment`;
      // }


      if (type == "diploma") {
        if (feeDetail.remainingBalance === 0) {
          // If there is no remaining balance, show the next installment count only
          const lastInstallment = currentInstallments[currentInstallments.length - 1] || 0;
          if (lastInstallment >= 12) {
            installmentDisplayText = "-";
          }
          else {
            installmentDisplayText = `${lastInstallment + 1}${getOrdinalSuffix(lastInstallment + 1)} Installment`;
          }
        } else {
          // If there is a remaining balance, include both current balance and next installment
          const lastInstallment = currentInstallments[currentInstallments.length - 1] || 0;
          // installmentDisplayText = `${lastInstallment}${getOrdinalSuffix(lastInstallment)} Balance, ${lastInstallment + 1}${getOrdinalSuffix(lastInstallment + 1)} Installment`;
          // For installments greater than 12, display a different format or apply additional conditions
          if (lastInstallment > 12) {
            installmentDisplayText = "-";
          }
          else if (lastInstallment === 12) {
            installmentDisplayText = `${lastInstallment}${getOrdinalSuffix(lastInstallment)} Balance`;
          }
          else {
            installmentDisplayText = `${lastInstallment}${getOrdinalSuffix(lastInstallment)} Balance, ${lastInstallment + 1}${getOrdinalSuffix(lastInstallment + 1)} Installment`;
          }
        }
      }
      else if (type == "advance_diploma") {
        if (feeDetail.remainingBalance === 0) {
          // If there is no remaining balance, show the next installment count only
          const lastInstallment = currentInstallments[currentInstallments.length - 1] || 0;
          if (lastInstallment >= 6) {
            installmentDisplayText = "-";
          }
          else {
            installmentDisplayText = `${lastInstallment + 1}${getOrdinalSuffix(lastInstallment + 1)} Installment`;
          }
        } else {
          // If there is a remaining balance, include both current balance and next installment
          const lastInstallment = currentInstallments[currentInstallments.length - 1] || 0;
          // installmentDisplayText = `${lastInstallment}${getOrdinalSuffix(lastInstallment)} Balance, ${lastInstallment + 1}${getOrdinalSuffix(lastInstallment + 1)} Installment`;
          // For installments greater than 12, display a different format or apply additional conditions
          if (lastInstallment > 6) {
            installmentDisplayText = "-";
          }
          else if (lastInstallment === 6) {
            installmentDisplayText = `${lastInstallment}${getOrdinalSuffix(lastInstallment)} Balance`;
          }
          else {
            installmentDisplayText = `${lastInstallment}${getOrdinalSuffix(lastInstallment)} Balance, ${lastInstallment + 1}${getOrdinalSuffix(lastInstallment + 1)} Installment`;
          }
        }
      }

      firstPage.drawText(` ${installmentDisplayText}`, { x: 190, y: 496.5, size: 9, font: ArialItalicLightEmbed, color: rgb(0, 0, 0) });
      // firstPage.drawText(` ${getOrdinalSuffix(feeDetail.installmentCounts)} `, { x: 196, y: 500.5, size: 6, font: calibriFontItalicBoldEmbed, color: rgb(0, 0, 0) });

      if (studentInfo) {


        const invoiceString = `JAO/CF-${getYear(feeDetail.sessionDate)}-${String(sequenceNumber).padStart(4, '0')}`;


        const x = 455;
        const y = 644.3;
        const size = 9;
        const font = calibriFontBoldEmbed;
        firstPage.drawText(toUpperCaseString1(invoiceString), { x, y, size, font, color: rgb(0, 0, 0) });

        // Measure the width of the text
        const textWidth = font.widthOfTextAtSize(invoiceString, size);
        // Draw the underline
        firstPage.drawLine({
          start: { x, y: y - 1 },
          end: { x: x + textWidth, y: y - 1 },
          thickness: 0.5,
          color: rgb(0, 0, 0),
        });

        // firstPage.drawText(invoiceString, { x: 450.5, y: 350, size: 9, font: calibriFontBoldEmbed, color: rgb(0, 0, 0) });
        firstPage.drawText(` ${toUpperCaseString1(studentInfo.name)}`, { x: 184, y: 618, size: 9, font: calibriFontBoldEmbed, color: rgb(0, 0, 0) });
        firstPage.drawText(` ${toUpperCaseString1(studentInfo.nric)}`, { x: 184, y: 607.5, size: 9, font: calibriFontBoldEmbed, color: rgb(0, 0, 0) });
        firstPage.drawText(` ${toUpperCaseString1(studentInfo.course)}`, { x: 184, y: 597.2, size: 9, font: calibriFontBoldEmbed, color: rgb(0, 0, 0) });
        firstPage.drawText(` ${toUpperCaseString11(studentInfo.startModuleDate)}`, { x: 184, y: 586, size: 9, font: calibriFontBoldEmbed, color: rgb(0, 0, 0) });
        firstPage.drawText('This is computer document advice no signature required.', { x: 75, y: 420, size: 9, font: calibriFontBoldEmbed, color: rgb(0, 0, 0) });
        // firstPage.drawText(` ${toUpperCaseString1(studentInfo.approver)}`, { x: 104, y: 439, size: 9, font: calibriFontEmbed, color: rgb(0, 0, 0) });

        firstPage.drawText(`$${feeDetail.courseFeeRemaining}`, { x: 156, y: 507.5, size: 9, font: ArialItalicLightEmbed, color: rgb(0, 0, 0) });
        if (feeDetail.discountAmount !== 0) {
          firstPage.drawText(` Discount:$${feeDetail.discountAmount}`, {
            x: 75, y: 486, size: 9, font: ArialItalicLightEmbed, color: rgb(0, 0, 0)
          });
        }

        // firstPage.drawText(` ${feeDetail.courseFeeRemaining}`, { x: 156, y: 507.5, size: 9, font: calibriFontItalicBoldEmbed, color: rgb(0, 0, 0) });

        // Add more student details as needed
      }

      // Save the PDF document
      // const pdfBytesEdited = await pdfDoc.save();
      // const blob = new Blob([pdfBytesEdited], { type: 'application/pdf' });
      // saveAs(blob, `${toUpperCaseString(studentInfo.name)}-COURSE-RECEIPT.pdf`);

      const pdfBytesModified = await pdfDoc.save();
      const pdfBlob = new Blob([pdfBytesModified], { type: 'application/pdf' });
      const pdfUrl = URL.createObjectURL(pdfBlob);
      // window.open(pdfUrl, '_blank');
      // saveAs(pdfBlob, `${toUpperCaseString(studentInfo.name)}-INS-${sequenceNumber}.pdf`);
      const studentName = studentInfo.name.replace(/\s+/g, '_');
      const fileName = `${studentName}_INS_${feeDetail.installmentCounts}.pdf`;

      setPdfUrl(pdfUrl);
      setPdfFileName(fileName);
      setOpen(true); // Open dialog

    } catch (error) {
      console.error('Error editing PDF:', error);
    }
  };



  const invoiceData = {
    companyName: 'JURONG ACADEMY',
    companyAddress: '134 Jurong Gateway Road,#03-307L (Head Office),Singapore 600134',
    companyPhone: '(65) 6635 5724',
    companyEmail: 'ask@ja.edu.sg',
    companyWebsite: 'https://ja.edu.sg',
  };

  const handleDownloadReceipt = (courseFeeDetails) => {
    const doc = new jsPDF('p', 'mm', 'a4');

    // Set font styles
    doc.setFont('helvetica', 'normal');
    doc.setFontSize(16);

    // Add company information at the top of the PDF
    doc.text(`Company Name: ${invoiceData.companyName}`, 10, 10);
    doc.text(`Company Address: ${invoiceData.companyAddress}`, 10, 20);
    doc.text(`Company Phone: ${invoiceData.companyPhone}`, 10, 30);
    doc.text(`Company Email: ${invoiceData.companyEmail}`, 10, 40);
    doc.text(`Company Website: ${invoiceData.companyWebsite}`, 10, 50);

    // Add title
    doc.text('Course Fee Details', 10, 70);

    // Define table columns
    const columns = ["Session ID", "Session Date", "Amount", "Payment Mode", "Remarks", "Payment Status"];

    // Define table rows
    const rows = courseFeeDetails.map(detail => [
      detail.sessionId,
      formatDateEnd(detail.sessionDate),
      detail.amount,
      detail.paymentMode,
      detail.remarks,
      detail.paymentStatus
    ]);

    // Add table
    doc.autoTable({
      head: [columns],
      body: rows,
      startY: 80, // Adjust startY to leave space for company information
    });

    // Save the PDF file with a specific name
    doc.save('course_fee_details.pdf');
  };

  const filteredStudents = students.filter(student =>
    student.name.toLowerCase().includes(searchText.toLowerCase())
  );
  console.log("hello1", filteredStudents.data);
  // const displayedStudents = filteredStudents.slice(
  //   (currentPage - 1) * studentsPerPage,
  //   currentPage * studentsPerPage
  // );
  // console.log("hello", displayedStudents.data);


  const exportToExcel = (data, fileName) => {
    const worksheet = XLSX.utils.json_to_sheet(data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
    XLSX.writeFile(workbook, `${fileName}.xlsx`);
  };


  return (
    <div>
      {loading ? (
        <p>Loading...</p>
      ) : (
        <div>
          <div style={{ display: "flex", alignItems: "center", gap: "10px", marginBottom: "10px" }}>
            <TextField
              label="Search by Name"
              variant="outlined"
              margin="normal"
              fullWidth
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
            />
            <Button
              variant="contained"
              color="primary"

              style={{backgroundColor: buttonBackgroundColor, color:'white'}}
              onClick={() =>
                exportToExcel(
                  students.map((student, index) => ({
                    // "S.NO": ((currentPage - 1) * studentsPerPage) + index + 1,
                    "S.NO": index + 1,
                    Name: student.name.toUpperCase(),
                    "NRIC/FIN": student.nric,
                    Email: student.email,
                    Phone: student.phone,
                    Status: "Active", // Modify if there's a dynamic status field
                  })),
                  "Students_Data"
                )
              }
            >
              Download Excel  
            </Button>
            <br />
            <br />
          </div>
          <Table aria-label="sticky table">
            <TableHead>
              <TableRow>
             
                <TableCell align='center' style={{ fontWeight: "bold" }} >S.NO</TableCell>
                <TableCell align='center'  style={{ fontWeight: "bold" }} >Name</TableCell>
                <TableCell align='center' style={{ fontWeight: "bold" }} >NRIC/FIN</TableCell>
                <TableCell align='center' style={{ fontWeight: "bold" }} >Email</TableCell>
                <TableCell align='center' style={{ fontWeight: "bold" }} >Phone</TableCell>
                <TableCell align='center' style={{ fontWeight: "bold" }} >Status</TableCell>
             
              </TableRow>
            </TableHead>
            <TableBody  sx={{
    '& .MuiTableCell-root': {
      textAlign: 'center',
    },
  }}>
              {filteredStudents.map((student, index) => (
                <TableRow key={student.id}>
                  {/* Calculate S.No based on the current page and index */}
                  <TableCell>
                    {/* {((currentPage - 1) * studentsPerPage) + index + 1} */}
                    {index + 1}
                  </TableCell>
                  <TableCell>
                    <span
                      title={`${student.name} details`}
                      style={{ cursor: 'pointer', textDecoration: 'underline', color: 'blue' }}
                      onClick={() => handleViewStudent(student, 'out')}
                    >
                      {student.name.toUpperCase()}
                    </span>
                  </TableCell>
                  {/* <TableCell>
                    <img
                      src='https://static.vecteezy.com/system/resources/thumbnails/002/318/271/small/user-profile-icon-free-vector.jpg'

                      alt="Profile"
                      style={{ width: '150px', height: '100px' }}
                    />
                  </TableCell> */}
                  <TableCell>{student.nric}</TableCell>
                  <TableCell>{student.email}</TableCell>
                  <TableCell>{student.phone}</TableCell>
                  <TableCell>
                    <Box display="flex" alignItems="center" mt={2} gap={2}>
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={() => handleViewStudent(student, 'out')}
                        style={{
                          borderRadius: '5px',
                          textTransform: 'none',
                          backgroundColor: '#2F58A0',
                          color: 'white',
                          padding: '8px 16px',
                        }}
                      >
                        Pay
                      </Button>
                      <Button
                        variant="contained"
                        onClick={() => handleshowStudent(student)}
                        style={{
                          borderRadius: '5px',
                          textTransform: 'none',
                          padding: '8px 16px',
                          backgroundColor: '#2F58A0',
                          color: 'white',

                        }}
                      >
                        Show
                      </Button>

                    </Box>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
          {/* <TablePagination
            rowsPerPageOptions={[10, 25, 100]}
            component="div"
            count={students.length}
            rowsPerPage={studentsPerPage}
            page={currentPage - 1}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            labelDisplayedRows={({ from, to }) => `${from}-${to} of ${students.length}`}
          /> */}
        </div>
      )}

      {selectedStudent && (
        <CustomPop
          showPop={showPop}
          handleClosePop={handleClosePop}
          handleSubmit={handleSubmit}
          selectedStudent={selectedStudent}
          amount={amount}
          handleAmountChange={handleAmountChange}
          remarks={remarks}
          handleRemarksChange={handleRemarksChange}
          modelOpen={modelOpen}
          registrationId={registrationId}

        />
      )}

      <Modal
        show={showModal}
        onHide={handleCloseModal}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        fullscreen
      >
        <Modal.Header closeButton>
          <Modal.Title>Student Details</Modal.Title>
          {/* <Button onClick={handleDownloadPDF} variant="contained" color="primary">Download PDF</Button> */}




        </Modal.Header>
        <Modal.Body>
          <div id="modalContent">
            {studentDetails && (
              <>

                <Paper style={{ padding: 20, border: '1px solid #ccc' }}>

                  <Grid container spacing={3}>
                    {/* Personal Details */}
                    <Grid item xs={12} sm={6}>
                      <Typography variant="body1"><strong>Name:</strong> {studentDetails.name || '-'}</Typography>
                    </Grid>
                    {/* <Grid item xs={12} sm={6}>
                      <Typography variant="body1"><strong>Surname:</strong> {studentDetails.student?.name || '-'}</Typography>
                    </Grid> */}
                    <Grid item xs={12} sm={6}>
                      <Typography variant="body1"><strong>Phone No:</strong> {studentDetails.handPhone || '-'}</Typography>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <Typography variant="body1"><strong>Date of Birth:</strong> {studentDetails.dob || '-'}</Typography>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <Typography variant="body1"><strong>Gender:</strong> {studentDetails.gender || '-'}</Typography>
                    </Grid>
                    {/* <Grid item xs={12} sm={6}>
                      <Typography variant="body1"><strong>Nationality:</strong> {studentDetails.nationality || '-'}</Typography>
                    </Grid> */}
                    <Grid item xs={12} sm={6}>
                      <Typography variant="body1"><strong>Passport No:</strong> {studentDetails.passportNo || '-'}</Typography>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <Typography variant="body1"><strong>Email:</strong> {studentDetails.email || '-'}</Typography>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <Typography variant="body1"><strong>Type:</strong> {studentDetails?.type || '-'}</Typography>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <Typography variant="body1"><strong>Course:</strong> {removeBracketedText(studentDetails?.batch.course) || '-'}</Typography>
                    </Grid>
                    {/* <Grid item xs={12} sm={6}>
                      <Typography variant="body1"><strong>Intake:</strong> {studentDetails?.intake || '-'}</Typography>
                    </Grid> */}
                    <Grid item xs={12} sm={6}>
                      <Typography variant="body1"><strong>Country of Birth:</strong> {studentDetails?.countryBirth || '-'}</Typography>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <Typography variant="body1"><strong>Nationality:</strong> {studentDetails?.nationality || '-'}</Typography>
                    </Grid>

                    <Grid item xs={12} sm={6}>
                      <Typography variant="body1">
                        <strong>Know About Program:</strong> {studentDetails?.knowAboutProgram || '-'}
                        {(studentDetails?.knowAboutProgram === 'referral' || studentDetails?.knowAboutProgram === 'other') && (
                          <>
                            {' - '}
                            {studentDetails?.knowAboutProgram === 'referral'
                              ? studentDetails?.referalfriend || '-'
                              : studentDetails?.otherDetails || '-'}
                          </>
                        )}
                      </Typography>
                    </Grid>
                    {/* <Grid item xs={12} sm={6}>
                      <Typography variant="body1"><strong>Application Signature:</strong> {studentDetails?.applicationSignature || '-'}</Typography>
                    </Grid> */}
                    <Grid item xs={12} sm={6}>
                      <Typography variant="body1"><strong>Date:</strong> {formatDate(studentDetails?.date) || '-'}</Typography>
                    </Grid>
                    {/* <Grid item xs={12} sm={6}>
                      <Typography variant="body1"><strong>Non-Singaporean:</strong> {studentDetails?.nonSingaporean || '-'}</Typography>
                    </Grid> */}
                    <Grid item xs={12} sm={6}>
                      <Typography variant="body1"><strong>Company:</strong> {studentDetails?.company || '-'}</Typography>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <Typography variant="body1"><strong>{studentDetails?.proofType === 'NRIC' ? 'NRIC :' : 'FIN :'}</strong> {studentDetails.student?.nric || '-'}</Typography>
                    </Grid>

                    {/* Address Details */}
                    <Grid item xs={12} sm={6}>
                      <Typography variant="body1">
                        <FontAwesomeIcon icon={faMapMarkerAlt} /> <strong>Address (Office):</strong> {studentDetails?.addressOffice || '-'}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <Typography variant="body1">
                        <FontAwesomeIcon icon={faMapMarkerAlt} /> <strong>Address (Home):</strong> {studentDetails?.addressHome || '-'}
                      </Typography>
                    </Grid>

                    <Grid item xs={12} sm={6}>
                      <Typography variant="body1">
                        <FontAwesomeIcon icon={faPhone} /> <strong>Phone (Office): </strong>{studentDetails?.phoneOffice || '-'}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <Typography variant="body1">
                        <FontAwesomeIcon icon={faPhone} /> <strong>Phone (Home): </strong>{studentDetails?.phoneHome || '-'}
                      </Typography>
                    </Grid>


                    {/* Emergency Contact */}
                    <Grid item xs={12} sm={6}>
                      <Typography variant="body1">
                        <FontAwesomeIcon icon={faPhone} /> <strong>Emergency Contact:</strong>
                      </Typography>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <Typography variant="body1"><strong>Contact Name:</strong> {studentDetails?.emergencyName || '-'}</Typography>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <Typography variant="body1"><strong>Relation:</strong> {studentDetails?.emergencyRelation || '-'}</Typography>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <Typography variant="body1"><strong>Phone:</strong> {studentDetails?.emergencyPhone || '-'}</Typography>
                    </Grid>
                  </Grid>
                </Paper>




                <Grid item xs={10} md={6}>
                  <Paper elevation={3} style={{ padding: '24px', height: '100%' }}>
                    <Typography variant="h6" gutterBottom style={{ fontWeight: 'bolder' }}>Course Schedule</Typography>
                    <TableContainer>
                      <Table style={{ borderCollapse: 'collapse', border: '1px solid #ccc' }}>
                        <TableHead style={{ backgroundColor: '#f5f5f5' }}>
                          <TableRow>
                            <TableCell style={{ fontWeight: 'bold', borderBottom: '2px solid #ccc' }}>Start Module</TableCell>
                            <TableCell style={{ fontWeight: 'bold', borderBottom: '2px solid #ccc' }}>Start Date</TableCell>
                            <TableCell style={{ fontWeight: 'bold', borderBottom: '2px solid #ccc' }}>End Date</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {scheduleData.map((schedule, index) => (
                            <TableRow key={index} style={{ backgroundColor: index % 2 === 0 ? '#f9f9f9' : '#ffffff' }}>
                              <TableCell style={{ borderBottom: '1px solid #ccc', padding: '8px' }}>{schedule.moduleDetail}</TableCell>
                              <TableCell style={{ borderBottom: '1px solid #ccc', padding: '8px' }}>{formatDateEnd(schedule.startDate)}</TableCell>
                              <TableCell style={{ borderBottom: '1px solid #ccc', padding: '8px' }}>{formatDateEnd(schedule.endDate)}</TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                      <Grid item xs={6}  >
                        <Paper elevation={3} style={{ padding: '24px', height: '100%' }}>
                          <Typography variant="h6" gutterBottom style={{ fontWeight: 'bolder' }} >Institution Details</Typography>
                          {studentDetails?.institutionDetails && studentDetails?.institutionDetails.length > 0 ? (
                            <TableContainer>
                              <Table style={{ borderCollapse: 'collapse', border: '1px solid #ccc' }}>
                                <TableHead>
                                  <TableRow >
                                    <TableCell style={{ fontWeight: 'bold' }}>Institution</TableCell>
                                    <TableCell style={{ fontWeight: 'bold' }}>Year</TableCell>
                                    <TableCell style={{ fontWeight: 'bold' }}>Full Time/Part Time</TableCell>
                                    <TableCell style={{ fontWeight: 'bold' }}>Qualifications Achieved</TableCell>
                                  </TableRow>
                                </TableHead>
                                <TableBody>
                                  {studentDetails.institutionDetails.map((detail, index) => (
                                    <TableRow key={index}>
                                      <TableCell>{detail.institution}</TableCell>
                                      <TableCell>{detail.year}</TableCell>
                                      <TableCell>{detail.fullTimeOrPartTime}</TableCell>
                                      <TableCell>{detail.qualificationsAchieved}</TableCell>
                                    </TableRow>
                                  ))}
                                </TableBody>

                              </Table>
                            </TableContainer>
                          ) : (
                            <Typography>No institution details available</Typography>
                          )}
                        </Paper>
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <Paper elevation={3} style={{ padding: '24px', height: '100%' }}>



                          <div >
                            {studentInfo && (
                              <div>
                                {/* <Typography variant="h6" component="div" gutterBottom>
                  Student Details
                </Typography> */}
                                {/* <div>ID: {studentInfo.id}</div>
                <div>Name: {studentInfo.name}</div>
                <div>Email: {studentInfo.email}</div>
                <div>Email: {studentInfo.sureName}</div>
                <div>Email: {studentInfo.addressHome}</div>
                <div>Email: {studentInfo.date}</div>
                <div>Email: {studentInfo.email}</div>
                <div>Email: {studentInfo.registrationFee}</div>
                <div>Email: {studentInfo.courseFee}</div>
                <div>Email: {studentInfo.totalPaidAmount}</div>
                <div>Email: {studentInfo.paymentStatus}</div>
                <div>Email: {studentInfo.registrationFeeRemaining}</div>

                <div>Email: {studentInfo.passportNo}</div>
                <div>Email: {studentInfo.course}</div>

                <div>Email: {studentInfo.nric}</div>

                <div>Email: {studentInfo.intakeId}</div>
                <div>Email: {studentInfo.approver}</div>
                <div>Email: {studentInfo.emailSent}</div>
                <div>Email: {studentInfo.courseFeeRemaining}</div> */}



                                {/* Add more student details here */}
                              </div>
                            )}

                            {data && (
                              <div>
                                <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                                  <Typography variant="h6" component="div" gutterBottom  style={{ fontWeight: 'bold' }}>
                                    Course Fee Details
                                  </Typography>
                                  <Button
                                    variant="contained"
                                    color="success"
                                    onClick={() => {
                                      setShowModal(false); // Close main modal
                                      handleViewStudent(dataForprop.student, 'in', dataForprop.id);                                     }}
                                  >
                                    Pay
                                  </Button>
                                </Box>
                                <TableContainer component={Paper}>
                                  <Table aria-label="course fee details table">
                                    <TableHead>
                                      <TableRow>
                                        <TableCell style={{ fontWeight: 'bold' }}>Installment Count</TableCell>
                                        {/* <TableCell>Session ID</TableCell> */}
                                        <TableCell style={{ fontWeight: 'bold' }}>Date</TableCell>
                                        <TableCell style={{ fontWeight: 'bold' }}>Amount</TableCell>
                                        <TableCell style={{ fontWeight: 'bold' }}>Discount Amount</TableCell>
                                        <TableCell style={{ fontWeight: 'bold' }}>Payment Mode</TableCell>
                                        <TableCell style={{ fontWeight: 'bold' }}>Remarks</TableCell>
                                        <TableCell style={{ fontWeight: 'bold' }}>Status</TableCell>
                                        <TableCell style={{ fontWeight: 'bold' }}>Action</TableCell>
                                        <TableCell style={{ fontWeight: 'bold' }}>Edit</TableCell>
                                        {/* <TableCell>Fee Type</TableCell> */}
                                      </TableRow>
                                    </TableHead>
                                    <TableBody>
                                      {data.courseFeeDetails.map((feeDetail, index) => (
                                        <TableRow key={index}>
                                          <TableCell >{Array.isArray(feeDetail.installmentCounts) ? feeDetail.installmentCounts.join(',') : feeDetail.installmentCounts}</TableCell>

                                          {/* <TableCell>{feeDetail.sessionId}</TableCell> */}
                                          <TableCell>{formatDateEnd(feeDetail.sessionDate)}</TableCell>
                                          <TableCell>{feeDetail.amount}</TableCell>
                                          <TableCell>{feeDetail.discountAmount}</TableCell>
                                          <TableCell>{feeDetail.paymentMode}</TableCell>
                                          <TableCell>{feeDetail.remarks}</TableCell>
                                          <TableCell>{feeDetail.status}</TableCell>
                                          <TableCell>
                                            <Button
                                              variant="contained"
                                              color="primary"
                                              startIcon={<DownloadIcon />}
                                              onClick={() => handlePdfEdit1(feeDetail, data.type, feeDetail.sequenceNumber)} // Pass installment data here

                                              style={{
                                                backgroundColor: buttonBackgroundColor
                                              }}
                                            >
                                              View Receipt
                                            </Button>
                                          </TableCell>
                                          <TableCell>
                                          <Button  style={{
                                                backgroundColor: buttonBackgroundColor
                                              }} color="primary" variant="contained" disabled={index !== data.courseFeeDetails.length - 1} onClick={() =>{  setShowModal(false); handleEdit(feeDetail, index, data.id, data.courseFeeDetails)}}  >Edit </Button>
                                          </TableCell>
                                          {/* <TableCell>{feeDetail.feeType}</TableCell> */}
                                        </TableRow>
                                      ))}
                                    </TableBody>
                                  </Table>
                                </TableContainer>

                                <Dialog open={open} onClose={() => setOpen(false)} fullScreen>
                                  <DialogTitle>View Receipt</DialogTitle>
                                  <DialogContent>
                                    {pdfUrl && (
                                      <iframe src={pdfUrl} width="100%" height="100%" style={{ minHeight: '90vh' }} title="PDF Preview"></iframe>
                                    )}
                                  </DialogContent>
                                  <DialogActions>
                                    <Button onClick={() => handleClose()} color="error" variant="contained">Close</Button>
                                    {pdfUrl && (
                                      <Button  style={{
                                        backgroundColor: buttonBackgroundColor
                                      }}
                                       color="primary" variant="contained" onClick={() => handleDownload()}>
                                        Download
                                      </Button>
                                    )}
                                  </DialogActions>
                                </Dialog>

                                {/* <Button
  variant="contained"
  color="success"
  style={{
    borderRadius: '5px',
    textTransform: 'none',
    backgroundColor: '#2F58A0',
    color: 'white',
    padding: '8px 16px',
   marginBottom: '20px' }}
  onClick={() => {
    setShowModal(false);           // Close main modal
    handleViewStudent(dataForprop.student, 'in', dataForprop.id); // Then open CustomPop
  }}
>
  Pay
</Button> */}


                                <Typography variant="h6" component="div" gutterBottom style={{ marginTop: '20px',fontWeight: 'bold' }}>
                                  Registration Fee Details
                                </Typography>
                                <TableContainer component={Paper}>
                                  <Table aria-label="installments paid table">
                                    <TableHead>
                                      <TableRow>
                                        {/* <TableCell>Session ID</TableCell> */}
                                        {/* <TableCell>Installment Count</TableCell> */}
                                        <TableCell style={{ fontWeight: 'bold' }}> Date</TableCell>
                                        <TableCell style={{ fontWeight: 'bold' }}>Amount</TableCell>
                                        <TableCell style={{ fontWeight: 'bold' }}>Discount Amount</TableCell>
                                        <TableCell style={{ fontWeight: 'bold' }}>Payment Mode</TableCell>
                                        <TableCell style={{ fontWeight: 'bold' }}>Remarks</TableCell>
                                        <TableCell style={{ fontWeight: 'bold' }}>Status</TableCell>
                                        <TableCell style={{ fontWeight: 'bold' }}>Action</TableCell>
                                        <TableCell style={{ fontWeight: 'bold' }}>Edit</TableCell>

                                        {/* <TableCell>Fee Type</TableCell> */}
                                      </TableRow>
                                    </TableHead>
                                    <TableBody>
                                      {data.installmentsPaid.map((installment, index) => (
                                        <TableRow key={index}>
                                          {/* <TableCell>{installment.sessionId}</TableCell> */}
                                          {/* <TableCell>{installment.installmentCounts}</TableCell> */}
                                          <TableCell>{formatDateEnd(installment.sessionDate)}</TableCell>
                                          <TableCell>{installment.amount}</TableCell>
                                          {/* <TableCell>{installment.discountAmount}</TableCell> */}
                                          {/* <TableCell>{data.amount1}</TableCell> */}
                                          {/* <TableCell>
                                            {data.amount1 !== 0 ? data.amount1 : installment.discountAmount}
                                          </TableCell> */}
                                          <TableCell>
                                            {index === 0 ? (data.amount1 !== 0 ? data.amount1 : installment.discountAmount) : installment.discountAmount}
                                          </TableCell>
                                          <TableCell>{installment.paymentMode}</TableCell>
                                          <TableCell>{installment.remarks}</TableCell>
                                          <TableCell>{installment.status}</TableCell>
                                          <TableCell>
                                            <Button
                                              variant="contained"
                                              // variant="contained"
                                              // color="primary"
                                              startIcon={<DownloadIcon />}
                                              onClick={() => handlePdfEdit(installment, index)} // Pass installment data here
                                              style={{
                                                backgroundColor: buttonBackgroundColor
                                              }}
                                            >
                                              View Receipt
                                            </Button>

                                          </TableCell>

                                          <TableCell>
                                          <Button  style={{
                                                backgroundColor: buttonBackgroundColor
                                              }} color="primary" variant="contained" disabled={index !== data.installmentsPaid.length - 1} onClick={() =>{  setShowModal(false); handleEdit(installment, index, data.id, data.installmentsPaid)}}
                                            >Edit </Button>
                                          </TableCell>

                                          {/* <TableCell>{installment.feeType}</TableCell> */}
                                        </TableRow>
                                      ))}
                                    </TableBody>
                                  </Table>
                                </TableContainer>
                              </div>
                            )}
                          </div>

                        </Paper>
                      </Grid>

                    </TableContainer>
                  </Paper>
                </Grid>

              </>
            )}
          </div>

        </Modal.Body>
      </Modal>
      <Modal
  show={showEditModal}
  onHide={() => setShowEditModal(false)}
  size="md"
  centered
  backdrop="static"
  dialogClassName="custom-modal-dialog"
>
  <Modal.Header closeButton style={{ backgroundColor: "#f0f2f5", borderBottom: "none" }}>
    <Modal.Title>Edit Payment</Modal.Title>
  </Modal.Header>
  <Modal.Body style={{ backgroundColor: "#ffffff" }}>
    {editData && (
      <EditPayment
        installment={editData.installment}
        index={editData.index}
        id={editData.id}
        allinstallments={editData.allinstallments}
        onClose={() => setShowEditModal(false)}
      />
    )}
  </Modal.Body>
</Modal>
    </div>


  );
};

export default StudentList;
 